import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LanguagePage } from './language/LanguagePage';
import { useKioskConfiguration } from '../contexts/kioskConfiguration/KioskConfigurationContext';
import { getRoutes } from '../contexts/kioskConfiguration/elementsContainer';
import useLanguage from '../contexts/language/LanguageContext';

export type RouteConfig = {
  path: string;
  component: React.ReactNode;
}

const routesDefault: RouteConfig[] = [
  {
    path: '/',
    component: <LanguagePage />,
  },
];


export const Router = (): React.ReactElement => {
  const [routes, setRoutes] = useState<RouteConfig[]>([
    ...routesDefault,
  ]);
  const kioskConfigurationContext = useKioskConfiguration()
  const languageContext = useLanguage()
  const selectedLanguageConfig = kioskConfigurationContext
    .kioskConfiguration
    .languages
    .find((l) => l.code === languageContext.language)
  const translations = selectedLanguageConfig
    ? selectedLanguageConfig.translations
    : kioskConfigurationContext.kioskConfiguration.languages[0].translations

  useEffect(() => {
    const dynamicRoutes = getRoutes(kioskConfigurationContext.kioskConfiguration.pages, translations)
    setRoutes([...routesDefault].concat(dynamicRoutes))
  }, [kioskConfigurationContext.kioskConfiguration, translations]);

  return (
    <Routes>
      {
        routes.map(route => {
          return <Route key={route.path} path={route.path} element={route.component}/>;
        })
      }
    </Routes>
  )
}
